// Simple React Validator v1.6.2 | Created By Dockwa | MIT License | 2017 - Present
!function (e, t) {
  "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? module.exports = t(require("react")) : e.SimpleReactValidator = t(e.React);
}(this, function (s) {
  "use strict";

  function f(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null == r) return;
      var n,
        s,
        a = [],
        i = !0,
        u = !1;
      try {
        for (r = r.call(e); !(i = (n = r.next()).done) && (a.push(n.value), !t || a.length !== t); i = !0);
      } catch (e) {
        u = !0, s = e;
      } finally {
        try {
          i || null == r.return || r.return();
        } finally {
          if (u) throw s;
        }
      }
      return a;
    }(e, t) || l(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function p(e, t) {
    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!r) {
      if (Array.isArray(e) || (r = l(e)) || t && e && "number" == typeof e.length) {
        r && (e = r);
        var n = 0,
          s = function () {};
        return {
          s: s,
          n: function () {
            return n >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[n++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: s
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a,
      i = !0,
      u = !1;
    return {
      s: function () {
        r = r.call(e);
      },
      n: function () {
        var e = r.next();
        return i = e.done, e;
      },
      e: function (e) {
        u = !0, a = e;
      },
      f: function () {
        try {
          i || null == r.return || r.return();
        } finally {
          if (u) throw a;
        }
      }
    };
  }
  function l(e, t) {
    if (e) {
      if ("string" == typeof e) return n(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
    }
  }
  function n(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function a(e) {
    return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function i(t, e) {
    var r = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e && (n = n.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function d(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = null != arguments[e] ? arguments[e] : {};
      e % 2 ? i(Object(r), !0).forEach(function (e) {
        o(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }
    return t;
  }
  function u(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  function o(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  var e = function () {
    function n() {
      var r = this,
        e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, n), o(this, "showMessageFor", function (e) {
        r.visibleFields.includes(e) || r.visibleFields.push(e), r.helpers.forceUpdateIfNeeded();
      }), o(this, "hideMessageFor", function (e) {
        var t = r.visibleFields.indexOf(e);
        -1 < t && r.visibleFields.splice(t, 1), r.helpers.forceUpdateIfNeeded();
      }), o(this, "helpers", {
        parent: this,
        passes: function (e, t, r, n) {
          return n.hasOwnProperty(e) ? !(this.isRequired(e, n) || !this.isBlank(t)) || !1 !== n[e].rule(t, r, this.parent) : (console.error("Rule Not Found: There is no rule with the name ".concat(e, ".")), !0);
        },
        isRequired: function (e, t) {
          return t[e].hasOwnProperty("required") && t[e].required;
        },
        isBlank: function (e) {
          return null == e || this.testRegex(e, /^[\s]*$/);
        },
        normalizeValues: function (e, t) {
          return [this.valueOrEmptyString(e), this.getValidation(t), this.getOptions(t)];
        },
        getValidation: function (e) {
          return e === Object(e) && Object.keys(e).length ? Object.keys(e)[0] : e.split(":")[0];
        },
        getOptions: function (e) {
          if (e === Object(e) && Object.values(e).length) {
            var t = Object.values(e)[0];
            return Array.isArray(t) ? t : [t];
          }
          return 1 < (t = e.split(":")).length ? t[1].split(",") : [];
        },
        valueOrEmptyString: function (e) {
          return null == e ? "" : e;
        },
        toSentence: function (e) {
          return e.slice(0, -2).join(", ") + (e.slice(0, -2).length ? ", " : "") + e.slice(-2).join(2 < e.length ? ", or " : " or ");
        },
        testRegex: function (e, t) {
          return null !== e.toString().match(t);
        },
        forceUpdateIfNeeded: function () {
          this.parent.autoForceUpdate && this.parent.autoForceUpdate.forceUpdate();
        },
        message: function (e, t, r, n) {
          r.messages = r.messages || {};
          var s = r.messages[e] || r.messages.default || this.parent.messages[e] || this.parent.messages.default || n[e].message;
          return s.replace(":attribute", this.humanizeFieldName(t));
        },
        humanizeFieldName: function (e) {
          return e.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/_/g, " ").toLowerCase();
        },
        element: function (e, t) {
          var r = t.element || this.parent.element;
          return r(e, t.className);
        },
        momentInstalled: function () {
          return !(!window || !window.moment) || (console.warn("Date validators require using momentjs https://momentjs.com and moment objects."), !1);
        },
        size: function (e, t) {
          return "string" === t || void 0 === t || "array" === t ? e.length : "num" === t ? parseFloat(e) : void 0;
        },
        sizeText: function (e) {
          return "string" === e || void 0 === e ? " characters" : "array" === e ? " elements" : "";
        }
      }), this.fields = {}, this.visibleFields = [], this.errorMessages = {}, this.messagesShown = !1, this.rules = d({
        accepted: {
          message: "The :attribute must be accepted.",
          rule: function (e) {
            return !0 === e;
          },
          required: !0
        },
        after: {
          message: "The :attribute must be after :date.",
          rule: function (e, t) {
            return r.helpers.momentInstalled() && moment.isMoment(e) && e.isAfter(t[0], "day");
          },
          messageReplace: function (e, t) {
            return e.replace(":date", t[0].format("MM/DD/YYYY"));
          }
        },
        after_or_equal: {
          message: "The :attribute must be after or on :date.",
          rule: function (e, t) {
            return r.helpers.momentInstalled() && moment.isMoment(e) && e.isSameOrAfter(t[0], "day");
          },
          messageReplace: function (e, t) {
            return e.replace(":date", t[0].format("MM/DD/YYYY"));
          }
        },
        alpha: {
          message: "The :attribute may only contain letters.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[A-Z]*$/i);
          }
        },
        alpha_space: {
          message: "The :attribute may only contain letters and spaces.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[A-Z\s]*$/i);
          }
        },
        alpha_num: {
          message: "The :attribute may only contain letters and numbers.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[A-Z0-9]*$/i);
          }
        },
        alpha_num_space: {
          message: "The :attribute may only contain letters, numbers, and spaces.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[A-Z0-9\s]*$/i);
          }
        },
        alpha_num_dash: {
          message: "The :attribute may only contain letters, numbers, and dashes.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[A-Z0-9_-]*$/i);
          }
        },
        alpha_num_dash_space: {
          message: "The :attribute may only contain letters, numbers, dashes, and spaces.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[A-Z0-9_-\s]*$/i);
          }
        },
        array: {
          message: "The :attribute must be an array.",
          rule: function (e) {
            return Array.isArray(e);
          }
        },
        before: {
          message: "The :attribute must be before :date.",
          rule: function (e, t) {
            return r.helpers.momentInstalled() && moment.isMoment(e) && e.isBefore(t[0], "day");
          },
          messageReplace: function (e, t) {
            return e.replace(":date", t[0].format("MM/DD/YYYY"));
          }
        },
        before_or_equal: {
          message: "The :attribute must be before or on :date.",
          rule: function (e, t) {
            return r.helpers.momentInstalled() && moment.isMoment(e) && e.isSameOrBefore(t[0], "day");
          },
          messageReplace: function (e, t) {
            return e.replace(":date", t[0].format("MM/DD/YYYY"));
          }
        },
        between: {
          message: "The :attribute must be between :min and :max:type.",
          rule: function (e, t) {
            return r.helpers.size(e, t[2]) >= parseFloat(t[0]) && r.helpers.size(e, t[2]) <= parseFloat(t[1]);
          },
          messageReplace: function (e, t) {
            return e.replace(":min", t[0]).replace(":max", t[1]).replace(":type", r.helpers.sizeText(t[2]));
          }
        },
        boolean: {
          message: "The :attribute must be a boolean.",
          rule: function (e) {
            return !1 === e || !0 === e;
          }
        },
        card_exp: {
          message: "The :attribute must be a valid expiration date.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^(([0]?[1-9]{1})|([1]{1}[0-2]{1}))\s?\/\s?(\d{2}|\d{4})$/);
          }
        },
        card_num: {
          message: "The :attribute must be a valid credit card number.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^\d{4}\s?\d{4,6}\s?\d{4,5}\s?\d{0,8}$/);
          }
        },
        currency: {
          message: "The :attribute must be a valid currency.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[\$£€¥]?(\d{1,3})(\,?\d{3})*\.?\d{0,2}$/);
          }
        },
        date: {
          message: "The :attribute must be a date.",
          rule: function (e) {
            return r.helpers.momentInstalled() && moment.isMoment(e);
          }
        },
        date_equals: {
          message: "The :attribute must be on :date.",
          rule: function (e, t) {
            return r.helpers.momentInstalled() && moment.isMoment(e) && e.isSame(t[0], "day");
          },
          messageReplace: function (e, t) {
            return e.replace(":date", t[0].format("MM/DD/YYYY"));
          }
        },
        email: {
          message: "The :attribute must be a valid email address.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
          }
        },
        in: {
          message: "The selected :attribute must be :values.",
          rule: function (e, t) {
            return t.includes(e);
          },
          messageReplace: function (e, t) {
            return e.replace(":values", r.helpers.toSentence(t));
          }
        },
        integer: {
          message: "The :attribute must be an integer.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^\-?\d*$/);
          }
        },
        max: {
          message: "The :attribute may not be greater than :max:type.",
          rule: function (e, t) {
            return r.helpers.size(e, t[1]) <= parseFloat(t[0]);
          },
          messageReplace: function (e, t) {
            return e.replace(":max", t[0]).replace(":type", r.helpers.sizeText(t[1]));
          }
        },
        min: {
          message: "The :attribute must be at least :min:type.",
          rule: function (e, t) {
            return r.helpers.size(e, t[1]) >= parseFloat(t[0]);
          },
          messageReplace: function (e, t) {
            return e.replace(":min", t[0]).replace(":type", r.helpers.sizeText(t[1]));
          }
        },
        not_in: {
          message: "The selected :attribute must not be :values.",
          rule: function (e, t) {
            return !t.includes(e);
          },
          messageReplace: function (e, t) {
            return e.replace(":values", r.helpers.toSentence(t));
          }
        },
        not_regex: {
          message: "The :attribute must not match the required pattern.",
          rule: function (e, t) {
            return !r.helpers.testRegex(e, "string" == typeof t[0] || t[0] instanceof String ? new RegExp(t[0]) : t[0]);
          }
        },
        numeric: {
          message: "The :attribute must be a number.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^\-?\d*\.?\d+$/);
          }
        },
        phone: {
          message: "The :attribute must be a valid phone number.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)$/) && !r.helpers.testRegex(e, /^\b(\d)\1{8,}\b$/);
          }
        },
        regex: {
          message: "The :attribute must match the required pattern.",
          rule: function (e, t) {
            return r.helpers.testRegex(e, "string" == typeof t[0] || t[0] instanceof String ? new RegExp(t[0]) : t[0]);
          }
        },
        required: {
          message: "The :attribute field is required.",
          rule: function (e) {
            return !r.helpers.isBlank(e);
          },
          required: !0
        },
        size: {
          message: "The :attribute must be :size:type.",
          rule: function (e, t) {
            return r.helpers.size(e, t[1]) == parseFloat(t[0]);
          },
          messageReplace: function (e, t) {
            return e.replace(":size", t[0]).replace(":type", r.helpers.sizeText(t[1]));
          }
        },
        string: {
          message: "The :attribute must be a string.",
          rule: function (e) {
            return a(e) === a("string");
          }
        },
        typeof: {
          message: "The :attribute is not the correct type of :type.",
          rule: function (e, t) {
            return a(e) === a(t[0]);
          },
          messageReplace: function (e, t) {
            return e.replace(":type", a(t[0]));
          }
        },
        url: {
          message: "The :attribute must be a url.",
          rule: function (e) {
            return r.helpers.testRegex(e, /^https?:\/\/[-a-z0-9@:%._\+~#=]{1,256}\.[a-z0-9()]{2,13}\b([-a-z0-9()@:%_\+.~#?&//=]*)$/i);
          }
        }
      }, e.validators || {}), e.locale && !n.locales.hasOwnProperty(e.locale) && console.warn("Locale not found! Make sure it is spelled correctly and the locale file is loaded.");
      var t = n.locales[e.locale] || {};
      Object.keys(this.rules).forEach(function (e) {
        r.rules[e].message = t[e] || r.rules[e].message;
      }), this.messages = e.messages || {}, this.className = e.className, this.autoForceUpdate = e.autoForceUpdate || !1, !1 === e.element ? this.element = function (e) {
        return e;
      } : e.hasOwnProperty("element") ? this.element = e.element : "object" === ("undefined" == typeof navigator ? "undefined" : a(navigator)) && "ReactNative" === navigator.product ? this.element = function (e) {
        return e;
      } : this.element = function (e, t) {
        return s.createElement("div", {
          className: t || r.className || "srv-validation-message"
        }, e);
      };
    }
    var e, t, r;
    return e = n, r = [{
      key: "addLocale",
      value: function (e, t) {
        this.locales[e] = t;
      }
    }], (t = [{
      key: "getErrorMessages",
      value: function () {
        return this.errorMessages;
      }
    }, {
      key: "showMessages",
      value: function () {
        this.messagesShown = !0, this.helpers.forceUpdateIfNeeded();
      }
    }, {
      key: "hideMessages",
      value: function () {
        this.messagesShown = !1, this.helpers.forceUpdateIfNeeded();
      }
    }, {
      key: "allValid",
      value: function () {
        for (var e in this.fields) if (!1 === this.fieldValid(e)) return !1;
        return !0;
      }
    }, {
      key: "fieldValid",
      value: function (e) {
        return this.fields.hasOwnProperty(e) && !0 === this.fields[e];
      }
    }, {
      key: "purgeFields",
      value: function () {
        this.fields = {}, this.errorMessages = {};
      }
    }, {
      key: "messageWhenPresent",
      value: function (e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        if (!this.helpers.isBlank(e) && this.messagesShown) return this.helpers.element(e, t);
      }
    }, {
      key: "messageAlways",
      value: function (e, t) {
        var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
        if (console.warn("The messageAlways() method is deprecated in SimpleReactValidator. Please see the documentation and switch to the messageWhenPresent() method."), t && this.messagesShown) return this.helpers.element(t, r);
      }
    }, {
      key: "check",
      value: function (e, t) {
        var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
        Array.isArray(t) || (t = t.split("|"));
        var n,
          s = r.validators ? d(d({}, this.rules), r.validators) : this.rules,
          a = p(t);
        try {
          for (a.s(); !(n = a.n()).done;) {
            var i = n.value,
              u = f(this.helpers.normalizeValues(e, i), 3),
              l = u[0],
              o = u[1],
              c = u[2];
            if (!this.helpers.passes(o, l, c, s)) return !1;
          }
        } catch (e) {
          a.e(e);
        } finally {
          a.f();
        }
        return !0;
      }
    }, {
      key: "message",
      value: function (e, t, r) {
        var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
        this.errorMessages[e] = null, this.fields[e] = !0, Array.isArray(r) || (r = r.split("|"));
        var s,
          a = n.validators ? d(d({}, this.rules), n.validators) : this.rules,
          i = p(r);
        try {
          for (i.s(); !(s = i.n()).done;) {
            var u = s.value,
              l = f(this.helpers.normalizeValues(t, u), 3),
              o = l[0],
              c = l[1],
              m = l[2];
            if (!this.helpers.passes(c, o, m, a)) {
              this.fields[e] = !1;
              var h = this.helpers.message(c, e, n, a);
              if (0 < m.length && a[c].hasOwnProperty("messageReplace") && (h = a[c].messageReplace(h, m)), this.errorMessages[e] = h, this.messagesShown || this.visibleFields.includes(e)) return this.helpers.element(h, n);
            }
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
      }
    }]) && u(e.prototype, t), r && u(e, r), Object.defineProperty(e, "prototype", {
      writable: !1
    }), n;
  }();
  return o(e, "version", "1.5.1"), o(e, "locales", {
    en: {}
  }), e;
});